module.exports = __webpack_public_path__ + "img/53.b58e36dd.jpg";